var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.isLoading
    ? _c(
        "div",
        [
          _vm.showLoadingAnimation
            ? _c("studip-progress-indicator", {
                attrs: {
                  description: _vm.searchDescription,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _c(
        "article",
        {
          staticClass: "studip-tree-table",
        },
        [
          _vm.courses.length > 0
            ? _c(
                "table",
                {
                  staticClass: "default studip-tree-table",
                },
                [
                  _c(
                    "caption",
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "search",
                          size: 20,
                        },
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$gettextInterpolate(
                              _vm.$ngettext(
                                'Ein Eintrag für den Begriff "%{searchterm}" gefunden',
                                '%{count} Einträge für den Begriff "%{searchterm}" gefunden',
                                _vm.courses.length
                              ),
                              {
                                count: _vm.courses.length,
                                searchterm: _vm.searchConfig.searchterm,
                              }
                            )
                          ) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("thead", [
                    _c("tr", [
                      _c("th"),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$gettext("Name")))]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$gettext("Information")))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.courses, function (course) {
                      return _c(
                        "tr",
                        {
                          key: course.id,
                          staticClass: "studip-tree-child studip-tree-course",
                        },
                        [
                          _c("td", [
                            _c("img", {
                              staticClass: "avatar-small",
                              attrs: {
                                src: course.meta.avatar.small,
                                title: course.attributes.title,
                                alt: "",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.courseUrl(course.id),
                                    title: _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "Zur Veranstaltung %{title}"
                                      ),
                                      {
                                        title: course.attributes.title,
                                      },
                                      true
                                    ),
                                    tabindex: "0",
                                  },
                                },
                                [
                                  course.attributes["course-number"]
                                    ? [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              course.attributes["course-number"]
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(course.attributes.title) +
                                      "\n                    "
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "course-dates",
                                attrs: {
                                  id: "course-dates-" + course.id,
                                },
                              }),
                              _vm._v(" "),
                              _c("tree-node-course-path", {
                                attrs: {
                                  "node-class": _vm.searchConfig.classname,
                                  "course-id": course.id,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("tree-course-details", {
                                attrs: {
                                  course: course.id,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _c(
                "studip-message-box",
                {
                  attrs: {
                    type: "info",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$gettextInterpolate(
                          _vm.$gettext(
                            'Es wurden keine Ergebnisse zu Ihrem Suchbegriff "%{term}" gefunden.'
                          ),
                          {
                            term: _vm.searchConfig.searchterm,
                          }
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
        ],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("colgroup", [
      _c("col", {
        staticStyle: {
          width: "30px",
        },
      }),
      _vm._v(" "),
      _c("col"),
      _vm._v(" "),
      _c("col"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }